/* eslint-disable complexity */
import React from 'react';

import { getImage } from 'gatsby-plugin-image';

import ArticleCard from '../../ui/Molecules/ArticleCard';
import PromoCard from '../../ui/Molecules/PromoCard';

import { getStaticUrl } from './getStaticUrl';
import { getTagList } from './getTagList';
import { linkResolver } from './linkResolver';

import { Color } from '../constants/Colors';
import { DocumentType } from '../constants/Enums';

export const getCardList = ({
  items,
  cardAppearance,
  isFromEdges,
  toComeLabel,
  pastLabel,
  promoCard,
}) => {
  if (!items.length) {
    return null;
  }

  const {
    promoCardLabel,
    promoCardLink: { url: promoCardLinkUrl, target: promoCardLinkTarget } = {},
    promoCardTitle,
    promoCardPos,
  } = promoCard || '';

  const cardList = items.map((post, index) => {
    const data = isFromEdges
      ? post.popular_in_post?.document?.data ||
        post.highlight_post?.document?.data ||
        {}
      : post?.node?.data || {};

    const lang = isFromEdges
      ? post.popular_in_post?.document?.lang ||
        post.highlight_post?.document?.lang ||
        ''
      : post?.node?.lang || '';

    const activeDocMeta = {
      lang,
      type: isFromEdges
        ? post.popular_in_post?.document?.type ||
          post.highlight_post?.document?.type ||
          DocumentType.HOMEPAGE
        : post?.node?.type || DocumentType.HOMEPAGE,
      uid: isFromEdges
        ? post.popular_in_post?.document?.uid ||
          post.highlight_post?.document?.uid ||
          ''
        : post?.node?.uid || '',
    };

    const isPast = data.is_past || false;
    const title = data.title?.text || '';

    const lede = data.lede || data.card_description || data.description || '';
    const tags = getTagList({
      lang,
      tag1: data.tag_1,
      tag2: data.tag_2,
      tag3: data.tag_3,
    });
    const categoryName = data.category?.document?.data?.category_name || '';
    const categoryColor =
      data.category?.document?.data?.category_color || Color.CLOUD_BURST;

    const localIllustration = data.illustration?.localFile || '';
    const illustrationAlt =
      data.illustration?.alt || 'article-illustration-card';
    const illustrationProps = {
      imageObject: getImage(localIllustration),
      imageUrl: getStaticUrl(localIllustration?.publicURL),
      altText: illustrationAlt,
    };

    return (
      <ArticleCard
        cardAppearance={cardAppearance}
        categoryColor={categoryColor}
        categoryName={categoryName}
        illustrationProps={illustrationProps}
        isPast={isPast}
        key={`${post}-${index}`}
        lede={lede}
        pastLabel={pastLabel}
        tags={tags}
        title={title}
        toComeLabel={toComeLabel}
        type={activeDocMeta.type}
        uid={linkResolver(activeDocMeta)}
      />
    );
  });

  if (
    cardList.length > promoCardPos &&
    promoCardTitle &&
    promoCardLinkUrl &&
    promoCardLabel
  ) {
    const newList = [...cardList];
    newList.splice(
      promoCardPos,
      0,
      <PromoCard
        illustrationAlt={'Wooclap blue logo square'}
        illustrationProps={{
          imageUrl: 'https://www.wooclap.com/images/wooclap-logo-square.png',
        }}
        label={promoCardLabel}
        linkTarget={promoCardLinkTarget}
        linkUrl={promoCardLinkUrl}
        title={promoCardTitle}
      />
    );

    return newList;
  }
  return cardList;
};
